module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "selectLocationPopup"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (!_vm.closedLocationId) ? [_c('h1', [_vm._v("Choose your nearest location")]), _vm._v(" "), _c('div', {
    staticClass: "locations"
  }, [_c('div', {
    staticClass: "location",
    on: {
      "click": function($event) {
        return _vm.selectLocation(1)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "d": "M176.381,71.938c17.639,0,32.173-14.3,32.173-31.94V7.821h94.892v32.177c0,17.641,14.648,31.94,32.287,31.94"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#808080"
    },
    attrs: {
      "x": "184.132",
      "y": "71.938",
      "width": "143.735",
      "height": "79.855"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "216.072",
      "y": "103.881",
      "width": "79.855",
      "height": "47.91"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FBB03B"
    },
    attrs: {
      "x": "152.244",
      "y": "151.786",
      "width": "207.511",
      "height": "23.955"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "d": "M463.609,288.037c-61.74,0-111.79-48.721-111.79-111.288h-191.64c0,62.566-50.05,111.539-111.79,111.539"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FBB03B"
    },
    attrs: {
      "x": "104.287",
      "y": "264.363",
      "width": "303.436",
      "height": "22.937"
    }
  }), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "447.64",
      "y": "319.473",
      "width": "31.94",
      "height": "63.88"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "32.42",
      "y": "319.473",
      "width": "31.94",
      "height": "63.88"
    }
  })]), _c('rect', {
    staticStyle: {
      "fill": "#808080"
    },
    attrs: {
      "x": "128.24",
      "y": "287.533",
      "width": "255.52",
      "height": "167.688"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "168.168",
      "y": "367.378",
      "width": "175.675",
      "height": "87.833"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#4D4D4D"
    },
    attrs: {
      "x": "96.3",
      "y": "287.533",
      "width": "31.94",
      "height": "167.688"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "96.3",
      "y": "407.306",
      "width": "31.94",
      "height": "47.91"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#4D4D4D"
    },
    attrs: {
      "x": "383.76",
      "y": "287.533",
      "width": "31.94",
      "height": "167.688"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "383.76",
      "y": "407.306",
      "width": "31.94",
      "height": "47.91"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FBB03B"
    },
    attrs: {
      "x": "80.325",
      "y": "455.221",
      "width": "351.34",
      "height": "24.455"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "49.01",
      "y": "479.174",
      "width": "413.98",
      "height": "23.956"
    }
  }), _c('rect', {
    attrs: {
      "y": "495.837",
      "width": "512",
      "height": "15.642"
    }
  }), _c('rect', {
    attrs: {
      "x": "49.01",
      "y": "471.853",
      "width": "413.98",
      "height": "15.642"
    }
  }), _c('polygon', {
    attrs: {
      "points": "352.456,439.528 336.815,439.528 336.815,374.876 175.185,374.876 175.185,439.528 159.544,439.528 159.544,359.234 352.456,359.234 "
    }
  }), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "159.544",
      "y": "336.293",
      "width": "192.912",
      "height": "15.642"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "208.554",
      "y": "311.267",
      "width": "94.892",
      "height": "15.642"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "224.196",
      "y": "407.202",
      "width": "15.642",
      "height": "15.642"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "272.163",
      "y": "407.202",
      "width": "15.642",
      "height": "15.642"
    }
  })]), _c('polygon', {
    attrs: {
      "points": "303.446,136.081 287.805,136.081 287.805,112.098 224.196,112.098 224.196,136.081 208.554,136.081 208.554,96.456 303.446,96.456 "
    }
  }), _c('path', {
    attrs: {
      "d": "M368.098,32.847v15.642h14.391c-3.395,9.011-12.413,15.642-22.685,15.642h-24.032v-0.014c-13.556,0-23.984-10.82-23.984-24.119V0.521H200.212v39.476c0,13.299-10.428,24.119-23.984,24.119v0.014h-24.035c-10.272,0-19.291-6.631-22.686-15.642h14.395V32.847h-31.283v7.821c0,21.196,18.021,39.104,39.574,39.104h25.078v63.609h-25.026v15.642h207.511v-15.642h-25.026V79.772h25.074c21.553,0,39.577-17.907,39.577-39.104v-7.821H368.098z M215.853,39.998V16.163h80.293v23.835c0,9.07,3.041,17.435,8.148,24.133h-16.49V23.462h-15.642V64.13h-9.385V23.462h-15.642V64.13h-7.299V23.462h-15.642V64.13h-16.49C212.813,57.433,215.853,49.068,215.853,39.998z M319.088,143.381h-56.31V120.44h-15.642v22.941h-54.224V79.772h126.175V143.381z"
    }
  }), _c('path', {
    attrs: {
      "d": "M463.511,199.69h-7.821v31.283h15.642v-14.625c14.477,3.232,24.332,15.447,24.332,31.395c0,17.634-14.151,31.999-31.631,32.23v-0.018c-28.155,0-54.161-10.67-73.694-30.044c-5.745-5.698-10.74-11.973-14.942-18.699v-0.239h-0.148c-10.057-16.196-15.493-35.003-15.493-54.745v-7.821H152.244v7.821c0,19.734-5.429,38.54-15.472,54.745h-0.17v0.274c-4.203,6.735-9.2,13.02-14.946,18.728c-18.527,18.406-42.862,28.964-69.337,30.008h-3.932c-17.674,0-32.054-14.463-32.054-32.24c0-15.364,10.201-27.9,24.334-31.316v14.547H56.31V199.69h-7.821c-26.801,0-47.796,21.117-47.796,47.966c0,26.261,21.169,47.728,47.275,47.957v0.103c1.542,0,40.668-0.093,40.668-0.093v151.202h-8.342v15.642h351.413v-15.642h-8.342V295.624h40.245c26.301,0,47.696-21.566,47.696-47.968C511.306,220.361,490.759,199.69,463.511,199.69z M132.737,261.073c1.323-1.314,2.611-2.656,3.866-4.022v14.59h15.642v-35.922c8.992-15.644,14.346-33.225,15.509-51.67h0.132v87.593h15.642v-87.593h16.684v87.593h15.642v-87.593h15.642v87.593h15.642v-87.593h17.727v87.593h15.642v-87.593h15.642v87.593h15.642v-87.593h16.684v87.593h15.642v-87.593h0.129c1.163,18.441,6.519,36.012,15.512,51.642v35.951h15.642v-14.643c1.256,1.365,2.544,2.705,3.869,4.019c7.541,7.48,15.927,13.826,24.958,18.967H107.934C116.904,274.85,125.238,268.524,132.737,261.073z M104.277,415.544h16.684v31.283h-16.684V415.544z M391.039,446.827v-31.283h16.684v31.283H391.039z M407.723,399.902h-16.684v-96.978h-15.642v143.902H262.778v-63.609h-15.642v63.609H136.603V302.925h-15.642v96.978h-16.684V295.625h303.446V399.902z"
    }
  }), _c('path', {
    attrs: {
      "d": "M471.332,302.925H455.69v8.728h-15.873v79.522h15.873v16.027h15.642v-16.027h16.067v-79.522h-16.067V302.925z M471.757,375.533h-16.298v-48.239h16.298V375.533z"
    }
  }), _c('path', {
    attrs: {
      "d": "M56.31,302.925H40.668v8.728H24.597v79.522h16.071v16.027H56.31v-16.027h15.869v-79.522H56.31V302.925z M56.537,375.533H40.238v-48.239h16.298V375.533z"
    }
  }), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g')]), _vm._v(" "), _c('p', [_vm._v("Liverpool St.")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EC2")])]), _vm._v(" "), _c('div', {
    staticClass: "location",
    on: {
      "click": function($event) {
        return _vm.selectLocation(2)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#B4826E"
    },
    attrs: {
      "d": "M316.492,308.418H195.507V172.52h120.986V308.418z M155.553,366.66v135.898h200.893V366.66H155.553z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#A06E5F"
    },
    attrs: {
      "d": "M297.359,312.786v189.772h-82.72V312.786h19.133V172.52h44.455v140.267L297.359,312.786L297.359,312.786z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#E6C8A0"
    },
    attrs: {
      "d": "M135.464,392.869v-31.063c0-2.681,2.141-4.854,4.783-4.854h231.505c2.642,0,4.783,2.173,4.783,4.854v31.063c0,2.681-2.141,4.854-4.783,4.854H140.246C137.605,397.723,135.464,395.55,135.464,392.869z M400.451,444.316H111.547c-2.642,0-4.783,2.173-4.783,4.854v21.355c0,2.681,2.141,4.854,4.783,4.854h288.903c2.642,0,4.783-2.173,4.783-4.854V449.17C405.234,446.489,403.092,444.316,400.451,444.316z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#C83741"
    },
    attrs: {
      "d": "M416.187,327.832L416.187,327.832c0,16.083-12.849,29.121-28.699,29.121H263.125h-14.252H124.511c-15.85,0-28.699-13.038-28.699-29.121l0,0l42.008-17.074c19.307-7.847,35.818-21.447,47.355-39.007l0,0c0.887-1.35,2.381-2.161,3.98-2.161h59.719h14.252h59.719c1.599,0,3.093,0.811,3.98,2.161l0,0c11.537,17.56,28.048,31.16,47.355,39.007L416.187,327.832z M376.536,170.659l-32.1-15.793c-28.283-13.915-52.879-34.487-71.738-60.003l0,0h-33.395l0,0c-18.859,25.515-43.455,46.088-71.738,60.003l-32.1,15.793v26.128h241.071V170.659z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#D2B48C"
    },
    attrs: {
      "d": "M443.5,478.291v21.355c0,2.681-2.141,4.854-4.783,4.854H73.282c-2.642,0-4.783-2.173-4.783-4.854v-21.355c0-2.681,2.141-4.854,4.783-4.854h306.739c0.605-0.813,0.978-1.814,0.978-2.912V449.17c0-2.681-2.141-4.854-4.783-4.854h24.235c2.642,0,4.783,2.173,4.783,4.854v21.355c0,1.098-0.373,2.099-0.978,2.912h34.46C441.359,473.438,443.5,475.61,443.5,478.291z M347.518,397.723h24.235c2.642,0,4.783-2.173,4.783-4.854v-31.063c0-2.681-2.141-4.854-4.783-4.854h-24.235c2.642,0,4.783,2.173,4.783,4.854v31.063C352.3,395.55,350.159,397.723,347.518,397.723z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#C5AB8C"
    },
    attrs: {
      "d": "M443.5,478.291v21.355c0,2.681-2.141,4.854-4.783,4.854h-24.235c2.642,0,4.783-2.173,4.783-4.854v-21.355c0-2.681-2.142-4.854-4.783-4.854h24.235C441.359,473.438,443.5,475.61,443.5,478.291z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#AA4141"
    },
    attrs: {
      "d": "M376.536,196.787h-90.119c-14.885-20.306-23.72-45.608-23.72-73.045c0-9.953,1.171-19.623,3.362-28.878h6.639c18.859,25.515,43.455,46.088,71.738,60.003l32.1,15.793V196.787z M374.18,310.758c-19.307-7.847-35.818-21.447-47.355-39.007c-0.887-1.35-2.381-2.161-3.98-2.161h-19.969c-0.311,3.598-0.479,7.239-0.479,10.92c0,28.99,9.863,55.596,26.304,76.443h58.788c15.85,0,28.699-13.038,28.699-29.121L374.18,310.758z"
    }
  }), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#963737"
    },
    attrs: {
      "d": "M440.221,325.315l-6.617,12.309c-10.058,18.711-29.385,30.353-50.389,30.353h-9.932H138.715h-9.932c-21.004,0-40.331-11.642-50.389-30.353l-6.617-12.309c-2.073-3.856,1.566-8.3,5.682-6.939l0,0c21.569,7.137,44.114,10.773,66.801,10.773h223.478c22.687,0,45.232-3.636,66.801-10.773l0,0C438.656,317.014,442.294,321.458,440.221,325.315z M107.986,180.995c10.058,18.711,29.385,30.353,50.39,30.353h9.932h175.383h9.932c21.004,0,40.331-11.642,50.39-30.353l6.617-12.309c2.073-3.856-1.566-8.301-5.682-6.939l0,0c-21.569,7.137-44.114,10.773-66.801,10.773H173.854c-22.687,0-45.232-3.636-66.801-10.773l0,0c-4.116-1.362-7.755,3.082-5.682,6.939L107.986,180.995z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#963737"
    },
    attrs: {
      "d": "M272.55,70.986c4.909,2.313,8.321,7.346,8.321,13.2l0,0c0,8.041-6.424,14.561-14.349,14.561h-21.046c-7.925,0-14.349-6.519-14.349-14.561l0,0c0-5.854,3.412-10.887,8.321-13.2c-5.105-4.622-8.321-11.345-8.321-18.833l0,0c0-13.939,11.136-25.238,24.872-25.238c13.737,0,24.872,11.3,24.872,25.238l0,0C280.872,59.64,277.656,66.364,272.55,70.986z"
    }
  })]), _c('path', {
    attrs: {
      "d": "M438.691,465.938h-25.958V449.17c0-6.812-5.51-12.354-12.283-12.354h-36.505v-31.594h7.807c6.773,0,12.283-5.542,12.283-12.354v-17.407c23.463-0.299,44.933-13.373,56.176-34.287l6.617-12.311c2.419-4.501,1.86-9.938-1.424-13.848c-3.249-3.869-8.441-5.345-13.222-3.761c-7.306,2.417-14.718,4.408-22.205,5.986c-0.16-0.078-0.319-0.159-0.486-0.227l-32.488-13.205c-17.978-7.307-33.162-19.816-43.911-36.176c-2.066-3.147-5.411-5.126-9.1-5.472v-43.314h29.63c23.783,0,45.623-13.144,56.995-34.302l6.618-12.31c2.419-4.502,1.86-9.938-1.424-13.848c-3.249-3.868-8.44-5.343-13.221-3.761c-8.991,2.975-18.139,5.314-27.394,7.016l-27.452-13.506c-24.452-12.03-46.368-29.551-63.666-50.837c2.695-3.668,4.292-8.206,4.292-13.113c0-5.267-1.863-10.271-5.139-14.2c3.246-5.043,5.139-11.037,5.139-17.468v-0.731c0-15.268-10.628-28.093-24.872-31.486V7.5c0-4.142-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v12.801c-14.244,3.393-24.873,16.218-24.873,31.486v0.731c0,6.431,1.893,12.425,5.14,17.469c-3.274,3.937-5.14,8.961-5.14,14.198c0,4.906,1.596,9.441,4.289,13.109c-17.294,21.283-39.217,38.815-63.663,50.842l-26.683,13.127c-0.242,0.119-0.474,0.251-0.698,0.392c-9.279-1.703-18.451-4.046-27.464-7.029c-4.784-1.582-9.973-0.107-13.222,3.762c-3.284,3.911-3.843,9.346-1.422,13.848l6.617,12.309c11.374,21.158,33.213,34.302,56.996,34.302h29.63v43.314c-3.688,0.346-7.032,2.325-9.1,5.471c-10.75,16.361-25.934,28.871-43.911,36.177l-33.022,13.421c-7.471-1.576-14.867-3.563-22.158-5.976c-4.784-1.582-9.973-0.106-13.222,3.762c-3.284,3.911-3.843,9.347-1.422,13.848l6.617,12.31c11.242,20.914,32.712,33.989,56.176,34.287v17.407c0,6.812,5.51,12.354,12.283,12.354h7.806v31.594h-36.505c-6.773,0-12.283,5.542-12.283,12.354v16.768H73.307c-6.787,0-12.308,5.542-12.308,12.354v21.355c0,6.811,5.521,12.353,12.308,12.353h365.385c6.786,0,12.308-5.542,12.308-12.354v-21.355C451,471.479,445.479,465.938,438.691,465.938z M348.945,436.816h-44.086v-31.594h44.086V436.816L348.945,436.816z M289.859,405.223v31.594h-67.72v-31.594H289.859z M308.992,262.09h-23.266v-43.242h23.266V262.09z M270.727,218.848v43.242h-29.455v-43.242L270.727,218.848L270.727,218.848z M238.626,84.186c0-1.337,0.379-2.622,1.049-3.729c4.796,2.813,10.373,4.435,16.324,4.435s11.528-1.621,16.324-4.435c0.669,1.104,1.048,2.386,1.048,3.73c0,3.893-3.072,7.061-6.849,7.061h-21.046C241.699,91.246,238.626,88.079,238.626,84.186z M238.626,51.787c0-9.579,7.793-17.373,17.373-17.373c9.58,0,17.372,7.793,17.372,17.373v0.731c0,9.579-7.793,17.373-17.372,17.373c-9.579,0-17.373-7.793-17.373-17.373V51.787z M170.874,161.595c26.798-13.184,50.777-32.497,69.564-55.948c1.618,0.387,3.304,0.598,5.037,0.598h21.046c1.733,0,3.417-0.211,5.035-0.598c18.792,23.455,42.761,42.76,69.566,55.947l6.499,3.197c-3.153,0.146-6.312,0.227-9.477,0.227H173.854c-3.165,0-6.324-0.082-9.477-0.227L170.874,161.595z M114.592,177.443l-3.535-6.577c20.401,6.076,41.494,9.153,62.796,9.153h164.292c21.303,0,42.394-3.077,62.796-9.153l-3.536,6.577c-8.754,16.287-25.531,26.404-43.783,26.404H158.376C140.124,203.848,123.347,193.73,114.592,177.443z M226.271,218.848v43.242h-23.266v-43.242L226.271,218.848L226.271,218.848z M140.643,317.707c20.357-8.274,37.612-22.301,49.986-40.617h130.739c12.374,18.316,29.629,32.343,49.986,40.617l8.777,3.567c-4.12,0.249-8.252,0.375-12.393,0.375H144.26c-4.141,0-8.274-0.126-12.394-0.375L140.643,317.707z M84.999,334.073l-3.535-6.578c20.4,6.076,41.493,9.153,62.796,9.153h223.478c21.303,0,42.396-3.077,62.796-9.153L427,334.073c-8.756,16.287-25.532,26.404-43.784,26.404H128.783C110.531,360.477,93.754,350.359,84.999,334.073z M142.964,375.477h226.072v14.746H142.964V375.477z M163.053,405.223h44.086v31.594h-44.086V405.223z M436,497h-360v-16.063h232.403c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H114.264v-14.121h283.469v14.121h-58.562c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5H436V497z"
    }
  }), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g')]), _vm._v(" "), _c('p', [_vm._v("Clerkenwell")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EC1")])])])] : _c('closed-location-notice', [_c('div', {
    staticClass: "back-link",
    on: {
      "click": function($event) {
        _vm.closedLocationId = null
      }
    }
  }, [_vm._v("‹ Back to locations")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ornaments"
  }, [_c('img', {
    staticClass: "lamps-left",
    attrs: {
      "src": require("../../assets/img/lamps-left.png"),
      "align": "Lamps ornaments"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lamps-right",
    attrs: {
      "src": require("../../assets/img/lamps-right.png"),
      "align": "Lamps ornaments"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05719c20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage/select-location-popup.vue
// module id = 543
// module chunks = 1